import Vue from 'vue';
import nativeAxios from 'axios';
import store from '../../store';
import router from '../../router';
import API from '../../service/api';

export default class BaseService {
  constructor() {
    this.API = API;
  }

  async get(url, data = {}) {
    let result = await nativeAxios.get(url, { params: data });
    result = result.data;
    if (!result.result && result.returnCode === '401') {
      localStorage.setItem('token', '');
      store.commit('setToke', '');
      router.push('/login');
      this.notice(result);
    }
    return result;
  }

  async post(url, data = {}) {
    let result = {};
    try {
      const storeId = store.state.storeId || '';
      // data.wechatEntityId = storeId;
      
      result = await nativeAxios.post(url, data);
   
      result = result.data;
    } catch (err) {
      result.data = {
        result: false,
        message: err.toString(),
      };
    }
    if (!result.result && result.returnCode === '401') {
      localStorage.token = '';
      store.commit('setToken', '');
      router.push('/login');
      this.notice(result);
    }
    return result;
  }

  async jsonPost(url, data = {}) {
    let result = {};
    try {
      const storeId = store.state.storeId || '';
      // data.wechatEntityId = storeId;
      result = await nativeAxios.post(url, data);
      result = result.data;
    } catch (err) {
      result.data = {
        result: false,
        message: err.toString(),
      };
    }
    if (!result.result && result.returnCode === '401') {
      localStorage.token = '';
      store.commit('setToken', '');
      router.push('/login');
      this.notice(result);
    }
    return result;
  }

  async upload(url, params = '', data = {}, folder) {
    let result = {};
    const path = url + params;
    const storeId = store.state.storeId || '';
    data.append('wechatEntityId', storeId);
    data.append('folderId', folder);
    try {
      result = await nativeAxios({
        method: 'POST',
        url: path,
        data,
        processData: false,
        contentType: false,
      });
      result = result.data;
    } catch (err) {
      result.data = {
        result: false,
        message: err.toString(),
      };
    }
    return result;
  }

  notice(result) {
    if (result.code === '200') {
      Vue.prototype.$Notice.success({
        title: 'Success',
        desc: result.message,
      });
    } else {
      Vue.prototype.$Notice.error({
        title: 'Failure',
        desc: result.message,
      });
    }
  }

  exportCsvFile(data, name = 'fans.csv') {
    var exportContent = "\uFEFF";
    const blob = new Blob([exportContent + data], { type: "text/plain;charset=utf-8" });
    const elink = document.createElement('a');
    elink.download = name;
    elink.style.display = 'none';
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  }

  downloadFile(url) {
    const btn = document.createElement('a');
    btn.href = url;
    btn.download = '';
    btn.style.display = 'none';
    document.body.appendChild(btn);
    btn.click();
    document.body.removeChild(btn);
  }
  downloadFileName(url) {
    var exportContent = "\uFEFF";
    const blob = new Blob([exportContent + data], { type: "text/plain;charset=utf-8" });
    const elink = document.createElement('a');
    elink.download = name;
    elink.style.display = 'none';
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  }
}



// WEBPACK FOOTER //
// ./src/service/services/BaseService.js